/* tslint:disable */
/* eslint-disable */
export enum OrderType {
  Purchase = 'purchase',
  Return = 'return'
}
